/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  PaymentElement
} from '@stripe/react-stripe-js';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { PaymentCycle } from "../../models/enumerations/payment-cycle";
import { Loader } from "../loader/loader";
import OrganizationSubscriptionService from "../../utilities/services/organization-subscription-service";
import { WarningItem } from "../warning-item/warning-item";
import { Button } from "../button/button";
import { Tag as TagComponent } from "../tag/tag";
import OrganizationService from "../../utilities/services/organization-service";
import { PlanType } from "../../models/enumerations/plan-type";
import { createLogger } from "../../utilities/logger";
import { UserLimitPlanType } from "../../models/enumerations/user-limit";
import { LicenseLimitPlanType } from "../../models/enumerations/license-limit";
import moment from "moment";
import { PlanIdPlanType } from "../../models/enumerations/plan-id";
import { AddOnId } from "../../models/enumerations/add-on-id";
import { User } from "../../models/interfaces/user";
import { Organization } from "../../models/interfaces/organization";
import { TextTypeInput } from "../forms";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PlanTypeLabels } from "../../models/plan-type";
import { AppContentType } from "../../models/enumerations/app-content-type";
import { AppContent } from "../../models/interfaces/app-content";
import { useParams } from 'react-router-dom';
import { OrganizationStatus } from "../../models/enumerations/organization-status";
import { OrganizationSubscription } from "../../models/interfaces/organization-subscription";
import LeadLinksService from "../../utilities/services/lead-links-service";
import { Price } from "../../models/interfaces/price";
import { Product } from "../../models/interfaces/product";
import { Utils } from "../../utilities/utils";
import { OrganizationType, OrganizationTypeLabel } from "../../models/enumerations/organization-type";
import { deleteField } from "firebase/firestore";
import { RadioGroupItem } from "../radio-group/radio-group-item";
import BillingService from "../../utilities/services/billing-service";

const log = createLogger("CheckoutFormCreate");

const NPE_FLOW_LEAD_TYPE = "npeLead";

interface CheckoutFormCreateProps {
  setUpgradeModalOpen?: Function;
  isCreating?: boolean;
  onChangePlan?: () => void,
  returnUrl: string;
  paymentFailed: Function;
  paymentSuccessful: Function;
  paymentCycle?: PaymentCycle;
  selectedProduct?: Product;
  selectedPrice?: Price;
  checkoutFlag?: number;
  products: any[];
  onInfoCreate?: (user: User, organization: Organization) => Promise<string>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

interface NPEPaymentPageParams {
  npeType: string;
  id: string;
}
const CheckoutFormCreate: React.FC<CheckoutFormCreateProps> = ({ selectedPrice, selectedProduct, setUpgradeModalOpen, isCreating, products, onChangePlan, paymentSuccessful, paymentFailed, returnUrl, paymentCycle, checkoutFlag, onInfoCreate, isLoading, setIsLoading }) => {
  const COMPONENT_CLASS = "c-checkoutform";
  const FORM_COMPONENT_CLASS = "p-link-create-account";

  const { t, i18n } = useTranslation();
  const { state } = useAuthState();
  const stripe = useStripe();
  const [customerId, setCustomerId] = useState<string>();
  const [clientSecret, setClientSecret] = useState('');
  const elements = useElements();
  const [user, setUser] = useState<any>();
  const [product, setProduct] = useState<any>(selectedProduct);
  const [planType, setPlanType] = useState<PlanType>(selectedProduct && selectedProduct.id ? PlanIdPlanType[selectedProduct.id] : PlanType.Core);
  const [paymentErrorKey, setPaymentErrorKey] = useState<string | null>(null);
  const [newPrice, setNewPrice] = useState<any>();
  const [totalPrice, setTotalPrice] = useState<number>();
  const [newPriceNext, setNewPriceNext] = useState<any>();
  const [coupons, setCoupons] = useState([] as any[]);
  const [subscriptionCoupon, setSubscriptionCoupon] = useState<string>();
  const [couponValue, setCouponValue] = useState<any>();
  const [discountError, setDiscountError] = useState<string>('');
  const [couponExists, setCouponExists] = useState<boolean>(true);
  const methods = useForm<any>();
  const { npeType, id } = useParams<NPEPaymentPageParams>();
  const isNPELink = npeType === NPE_FLOW_LEAD_TYPE;
  const params = new URLSearchParams(window.location.search);
  const couponId = state.user?.npeTemp?.couponId ? state.user.npeTemp.couponId : params.get("couponId");
  const {
    register,
  } = methods;
  useEffect(() => {
    if (isCreating && checkoutFlag && checkoutFlag > 0) {
      handleSubscriptionStart();
    }
  }, [checkoutFlag]);

  useEffect(() => {
    if (isCreating && state?.temp?.user && state?.temp?.product) {
      setUser(state.temp.user);
      setProduct({ ...state.temp.product, priceInfo: state.temp.product.priceInfo.find((item: any) => paymentCycle === PaymentCycle.Monthly ? item.interval === "month" : item.interval !== "month") });
    }
  }, [isCreating, paymentCycle, state.temp]);

  useEffect(() => {
    if (product && product.id) {
      const purchasedPlanType = PlanIdPlanType[product.id];

      setPlanType(purchasedPlanType);
    }

  }, [product]);

  let priceToShow = "";
  if (!isCreating && selectedPrice && selectedPrice.unit_amount) {
    priceToShow = (selectedPrice.unit_amount / 100).toFixed(2);
  }

  useEffect(() => {
    if (!elements) {
      return;
    }
    const element = elements.getElement('payment');
    if (!element) {
      return;
    }
    element.on('ready', () => {
      setIsLoading(false);
    });
  }, [elements, setIsLoading]);

  useEffect(() => {
    const runCheckout = async () => {
      if (!clientSecret || !customerId || !stripe || !elements) {
        return;
      }

      setIsLoading(true);

      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}${returnUrl}`,
        },
        redirect: "if_required",
      });

      if (error) {
        log.error("Stripe confirmSetup error during checkout", {
          exception: error,
          customerId,
        });
        setPaymentErrorKey('stripeConfirmFailed');
        paymentFailed(true);
        setIsLoading(false);
        return;
      }

      const paymentMethodId =
        typeof setupIntent.payment_method === "string"
          ? setupIntent.payment_method
          : undefined;

      if (!paymentMethodId) {
        log.warn("Checkout failed: no payment method returned from Stripe", {
          customerId,
        });
        setPaymentErrorKey('stripePaymentMethodFailed');
        paymentFailed(true);
        setIsLoading(false);
        return;
      }

      let org: Organization | null = null;
      let orgSub: OrganizationSubscription[] | null = null;
      try {
        org = await OrganizationService.get(
          isCreating ? state.temp.organization.id : state.organization.id!
        );

        orgSub = await OrganizationSubscriptionService.getByOrganizationId(
          isCreating ? state.temp.organization.id : state.organization.id!
        );
      } catch (e) {
        log.error("Failed to load organization or subscription before checkout", {
          exception: e,
          organizationId: isCreating ? state.temp.organization?.id : state.organization?.id,
        });
        setIsLoading(false);
        paymentFailed(true);
        return;
      }

      if (!org || !orgSub || orgSub.length === 0) {
        log.warn("Checkout blocked: organization or subscription not found", {
          organizationId: isCreating ? state.temp.organization?.id : state.organization?.id,
          customerId,
        });
        setIsLoading(false);
        paymentFailed(true);
        return;
      }
      const resolvedOrg = org;
      const resolvedOrgSub = orgSub;

      try {
        const response = await BillingService.completeCheckoutCreate({
          customerId,
          paymentMethodId,
          selectedPriceId: selectedPrice?.id ? selectedPrice.id : product.priceInfo.id,
          userAddOnPriceId: products.find((item) => item.product.id === AddOnId.User)
            .prices.find((item: any) => item.data.active === true).id,
          licenseAddOnPriceId: products.find((item) => item.product.id === AddOnId.License)
            .prices.find((item: any) => item.data.active === true).id,
          couponId: subscriptionCoupon,
        });

        const startDate = new Date();
        const renewDate = new Date(response.currentPeriodEnd * 1000);

        const previousStatus = resolvedOrg.status;
        resolvedOrg.plan = { value: planType, label: PlanTypeLabels[planType] };
        resolvedOrg.userLimit = UserLimitPlanType[planType];
        resolvedOrg.mySymmioLicense = LicenseLimitPlanType[planType];
        resolvedOrg.status = OrganizationStatus.Active;
        await OrganizationService.save(resolvedOrg);

        if (previousStatus !== OrganizationStatus.Active) {
            log.warn("Organization status changed", {
                organizationId: resolvedOrg.id,
                organizationName: resolvedOrg.name,
                fromStatus: OrganizationStatus[Number(previousStatus)] ?? previousStatus,
                fromStatusValue: previousStatus,
                toStatus: OrganizationStatus[Number(resolvedOrg.status)] ?? resolvedOrg.status,
                toStatusValue: resolvedOrg.status,
                planType,
                source: "checkout-form-create",
            });
        }

        resolvedOrgSub[0].price = response.planAmount || 0;
        resolvedOrgSub[0].stripePlanSubscription = response.planSubscriptionId;
        resolvedOrgSub[0].stripeAddOnSubscription = response.addOnSubscriptionId;
        resolvedOrgSub[0].startDate = startDate.toISOString();
        resolvedOrgSub[0].renewDate = renewDate.toISOString();
        resolvedOrgSub[0].userLimit = UserLimitPlanType[planType];
        resolvedOrgSub[0].mySymmioLicense = LicenseLimitPlanType[planType];
        resolvedOrgSub[0].plan = {
          label: PlanTypeLabels[planType],
          value: planType,
        };
        resolvedOrgSub[0].paymentCycle = {
          label: PaymentCycle[paymentCycle === PaymentCycle.Yearly ? PaymentCycle.Yearly : PaymentCycle.Monthly],
          value: paymentCycle === PaymentCycle.Yearly ? PaymentCycle.Yearly : PaymentCycle.Monthly,
        };
        resolvedOrgSub[0].accountType = {
          label: OrganizationTypeLabel[OrganizationType.Paid],
          value: OrganizationType.Paid,
        };
        resolvedOrgSub[0].trialLength = deleteField() as unknown as RadioGroupItem;

        await OrganizationSubscriptionService.save(resolvedOrgSub[0]);

        log.info("Plan purchased", {
          planType,
          customerId,
          organizationId: isCreating ? state.temp.organization?.id : state.organization?.id,
          organizationName: resolvedOrg.name,
          organizationStatus: OrganizationStatus[Number(resolvedOrg.status)] ?? resolvedOrg.status,
          subscriptionId: response.planSubscriptionId,
          addOnSubscriptionId: response.addOnSubscriptionId,
          price: response.planAmount || 0,
          paymentCycle: paymentCycle === PaymentCycle.Yearly ? "yearly" : "monthly",
          couponId: subscriptionCoupon,
        });

        paymentSuccessful(true);
      } catch (err) {
        log.error("Failed to complete checkout", {
          exception: err,
          organizationId: isCreating ? state.temp.organization?.id : state.organization?.id,
        });
        setPaymentErrorKey('checkoutCompleteFailed');
        paymentFailed(true);
      } finally {
        setIsLoading(false);
      }
    };

    runCheckout();
  }, [
    clientSecret,
    customerId,
    stripe,
    elements
  ]);

  useEffect(() => {
    if (product && product.priceInfo && isCreating) {
      const price = Number((product?.priceInfo.unit_amount / 100).toFixed(2));
      setTotalPrice(price);
    }
    else if (selectedPrice && selectedPrice.unit_amount !== undefined) {
      const price = Number((selectedPrice.unit_amount / 100).toFixed(2));
      setTotalPrice(price);
    }
  }, [product]);

  useEffect(() => {
    if (coupons.length === 0) {
      setNewPrice(null);
      setNewPriceNext(null);
    }
  }, [coupons.length]);

  const paymentErrorMessages: Record<string, { title: string; text: string }> = {
    stripeNotLoaded: { title: t('pricing.checkoutPage.paymentError.stripeNotLoaded.title'), text: t('pricing.checkoutPage.paymentError.stripeNotLoaded.text') },
    stripeSubmitFailed: { title: t('pricing.checkoutPage.paymentError.stripeSubmitFailed.title'), text: t('pricing.checkoutPage.paymentError.stripeSubmitFailed.text') },
    checkoutSetupFailed: { title: t('pricing.checkoutPage.paymentError.checkoutSetupFailed.title'), text: t('pricing.checkoutPage.paymentError.checkoutSetupFailed.text') },
    stripeConfirmFailed: { title: t('pricing.checkoutPage.paymentError.stripeConfirmFailed.title'), text: t('pricing.checkoutPage.paymentError.stripeConfirmFailed.text') },
    stripePaymentMethodFailed: { title: t('pricing.checkoutPage.paymentError.stripePaymentMethodFailed.title'), text: t('pricing.checkoutPage.paymentError.stripePaymentMethodFailed.text') },
    checkoutCompleteFailed: { title: t('pricing.checkoutPage.paymentError.checkoutCompleteFailed.title'), text: t('pricing.checkoutPage.paymentError.checkoutCompleteFailed.text') },
  };

  const handleSubmit = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    handleSubscriptionStart();
  }

  const handleSubscriptionStart = async () => {
    if (!stripe || !elements) {
      setPaymentErrorKey('stripeNotLoaded');
      setIsLoading(false);
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      log.error("Stripe elements submit error during checkout", {
        exception: submitError,
      });
      setPaymentErrorKey('stripeSubmitFailed');
      paymentFailed(true);
      return;
    }

    setIsLoading(true);

    if (isCreating && onInfoCreate) {
      let result = null;

      if (isNPELink && state.user) {
        const leadLink = id ? await LeadLinksService.get(id) : null;

        const organization = {
          appContent: {
            [AppContentType.PAIN]: {} as AppContent,
            [AppContentType.BEHAVIORAL_HEALTH]: {} as AppContent,
          },
          status: OrganizationStatus.Active,
          name: state.user.npeTemp!.orgName,
          industry: Utils.getIndustryObject(state.user.npeTemp!.orgIndustry),
          leadLinkId: id ? id : "",
          orgDefaultContentConfig: leadLink ? leadLink.orgDefaultContentConfig : undefined,
        };

        result = onInfoCreate(state.temp.user, organization);
      } else {
        result = onInfoCreate(state.temp.user, state.temp.organization);
      }

      if (await result !== "SUCCESS") {
        log.warn("Checkout blocked: organization setup did not succeed", {
          result: result?.toString(),
        });
        setDiscountError(result!.toString());
        setIsLoading(false);
        return;
      }
    }

    try {
      const setupIntentResponse = await BillingService.createCheckoutSetupIntent({
        email: isCreating ? `${user.email}` : `${state.user?.email}`,
        name: isCreating
          ? `${user.firstName} ${user.lastName}`
          : `${state.user?.firstName} ${state.user?.lastName}`,
        preferredLocale: i18n.language,
      });

      setCustomerId(setupIntentResponse.customerId);
      setClientSecret(setupIntentResponse.clientSecret);
    } catch (err) {
      log.error("Failed to create checkout setup intent", {
        exception: err,
      });
      setPaymentErrorKey('checkoutSetupFailed');
      paymentFailed(true);
    } finally {
      setIsLoading(false);
    }
  };

  function calculateNextPayment(priceInfo: any): React.ReactNode {
    const today = new Date();
    const nextBillingDay = new Date(today);
    if (priceInfo) {
      if (priceInfo.interval === 'month') {
        nextBillingDay.setMonth(today.getMonth() + priceInfo.interval_count);
      } else if (priceInfo.interval === 'year') {
        nextBillingDay.setFullYear(today.getFullYear() + priceInfo.interval_count);
      }
      else {
        nextBillingDay.setFullYear(today.getFullYear() + 1);
      }

      // This part adjusts the last day of the month if it doesn't exist in the next month
      if (priceInfo.interval === 'month') {
        while (nextBillingDay.getMonth() !== (today.getMonth() + priceInfo.interval_count) % 12) {
          nextBillingDay.setDate(nextBillingDay.getDate() - 1);
        }
      }
    }
    return priceInfo ? `${nextBillingDay.toLocaleString('default', { month: 'short' })} ${nextBillingDay.getDate()}, ${nextBillingDay.getFullYear()}` : '';
  }

  const handleApplyCode = async () => {
    setDiscountError("");

    if (coupons.length > 0) {
      setDiscountError(t('pricing.checkoutPage.discountErrors.only1'));
      return;
    }

    if (!couponValue) {
      setDiscountError(t('pricing.checkoutPage.discountErrors.enterValid'));
      return;
    }

    const result = await BillingService.validatePromotionCode({
      code: couponValue,
      customerId,
      productId: product.id,
      paymentCycle: paymentCycle!,
      totalPrice: Number(totalPrice),
    }).catch((e) => {
      log.error("Failed to validate promotion code", {
        exception: e,
        couponValue,
        customerId,
      });
      return null;
    });

    if (!result || !result.valid || !result.couponId) {
      setDiscountError(result?.message || t('pricing.checkoutPage.discountErrors.enterValid'));
      return;
    }

    setCoupons([result]);
    setSubscriptionCoupon(result.couponId);
    setCouponValue("");

    const updatedPrice = Number(totalPrice) - Number(result.discountAmount || 0);
    setNewPrice(updatedPrice > 0 ? updatedPrice : 0);

    if (result.applyToNextPayment) {
      setNewPriceNext(updatedPrice > 0 ? updatedPrice : 0);
    } else {
      setNewPriceNext(null);
    }
  };

  useEffect(() => {
    const resolveCoupon = async () => {
      if (!couponId || !totalPrice || !product?.id || paymentCycle == null) {
        setCouponExists(false);
        return;
      }

      const result = await BillingService.resolvePromotionCode({
        couponId,
        productId: product.id,
        paymentCycle,
        totalPrice: Number(totalPrice),
      }).catch((e) => {
        log.error("Failed to resolve promotion code", {
          exception: e,
          couponId,
        });
        return null;
      });

      if (!result || !result.valid || !result.couponId) {
        setCouponExists(false);
        return;
      }

      setSubscriptionCoupon(result.couponId);

      const updatedPrice = Number(totalPrice) - Number(result.discountAmount || 0);
      setNewPrice(updatedPrice > 0 ? updatedPrice : 0);

      if (result.applyToNextPayment) {
        setNewPriceNext(updatedPrice > 0 ? updatedPrice : 0);
      } else {
        setNewPriceNext(null);
      }
    };

    resolveCoupon();
  }, [couponId, paymentCycle, product?.id, totalPrice]);

  return (
    <div className={`${COMPONENT_CLASS}`}>
      <Loader isVisible={isLoading} />
      {paymentErrorKey && (
        <div style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto' }}>
          <WarningItem
            iconColor="#E7514F"
            onClose={() => { setPaymentErrorKey(null); }}
            backgroundColor="#FFE9E5"
            title={paymentErrorMessages[paymentErrorKey]?.title || t('pricing.checkoutPage.paymentDeclined.banner.title')}
            text={paymentErrorMessages[paymentErrorKey]?.text || t('pricing.checkoutPage.paymentDeclined.banner.subText')}
          />
        </div>
      )}

      <div className={`${!isCreating ? `${COMPONENT_CLASS}__container-modal` : `${COMPONENT_CLASS}__container`}`}>
        <div className={`${COMPONENT_CLASS}__summary`}>
          <div className={`${COMPONENT_CLASS}_summary_line`}>
            <div style={{ fontSize: '20px' }}>{product?.name ?? ''}</div>
            <div style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={onChangePlan}>{t('pricing.checkoutPage.changePlan')}</div>
          </div>
          {!isCreating && state.organization && state.organization.plan && state.organization.plan.value !== undefined && (
            <div style={{ flexDirection: 'column', alignItems: 'start' }} className={`${COMPONENT_CLASS}_summary_line`}>
              <div style={{ fontWeight: 'bold' }}>{t('pricing.checkoutPage.accChange')}</div>
              <ul style={{ marginLeft: '1rem', marginTop: '1rem', listStyleType: 'disc' }}>
                <li>{t('pricing.checkoutPage.userLimit', { starterLimit: UserLimitPlanType[state.organization.plan.value], businessLimit: UserLimitPlanType[planType] })}</li>
                <li>{t('pricing.checkoutPage.licenseLimit', { starterLimit: LicenseLimitPlanType[state.organization.plan.value], businessLimit: LicenseLimitPlanType[planType] })}</li>
                <li>
                  {paymentCycle === PaymentCycle.Yearly
                    ?
                    t('pricing.checkoutPage.year', { price: priceToShow, date: moment(new Date()).format('MMMM D Y') })
                    :
                    t('pricing.checkoutPage.month', { price: priceToShow, date: moment(new Date()).format('MMMM D Y') })}
                </li>
              </ul>
            </div>
          )}
          <hr className={`${COMPONENT_CLASS}_divider ${!isCreating ? `${COMPONENT_CLASS}__upgrade-divider` : ""}`} />
          <div className={`${COMPONENT_CLASS}_summary_line`}>
            <div style={{ fontWeight: 'bold' }}>{t('pricing.checkoutPage.todayPay')}</div>
            {(newPrice || newPrice === 0) &&
              <div style={{ display: 'flex' }}>
                <div style={{ textDecoration: 'line-through', marginRight: '0.5rem', color: 'gray' }}>
                  ${totalPrice?.toFixed(2) ?? '...'}
                </div>
                <div>${newPrice.toFixed(2) ?? '...'}</div>
              </div>
            }
            {(!newPrice && newPrice !== 0) &&
              <div>
                ${totalPrice?.toFixed(2) ?? '...'}
              </div>
            }
          </div>
          {isCreating && (
            <>
              <hr className={`${COMPONENT_CLASS}_divider ${!isCreating ? `${COMPONENT_CLASS}__upgrade-divider` : ""}`} />
              <div className={`${COMPONENT_CLASS}_summary_line`}>
                <div style={{ fontWeight: 'bold' }}>{t('pricing.checkoutPage.nextPaymentDate', { date: product && product.priceInfo ? calculateNextPayment(product?.priceInfo) : "..." }
                )}</div>
                <div>${newPriceNext ? newPriceNext.toFixed(2) : totalPrice?.toFixed(2) ?? '...'}</div>
              </div>
            </>
          )}
          {
            !couponExists && (
              <><form style={!isCreating ? { display: 'flex', justifyContent: 'space-between', gap: '1rem', padding: '0rem 1.25rem 1.25rem 1.25rem' }
                : { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexFlow: 'wrap', paddingLeft: '1.25rem', paddingRight: '1.25rem', paddingBottom: '1.25rem' }}>            <div style={{ fontWeight: '300' }}>
                  <TextTypeInput
                    id="discountCode"
                    type="text"
                    label={t('pricing.checkoutPage.discount')}
                    inputClassName={`${!isCreating && `${COMPONENT_CLASS}__discount-field`} ${(discountError) && `${FORM_COMPONENT_CLASS} -showerror`}`}
                    hideLabel={true}
                    style={isCreating ? { width: 'auto' } : { width: '100%' }}
                    registerHook={register}
                    registerOptions={{
                      value: couponValue,
                      onChange: (e) => { setCouponValue(e.target.value); },
                      onBlur: (e) => { if (discountError && e.target.value === '') { setDiscountError(''); } },
                    }} />
                </div>
                {(discountError) && (
                  <div role="alert" className={`${FORM_COMPONENT_CLASS} -coupon-error`}>
                    {discountError}
                  </div>
                )}
                <div>
                  <Button type="default" disabled={isLoading} buttonType="button" onClick={handleApplyCode} buttonText="Apply" />
                </div>
              </form><div style={{ marginLeft: '1.25rem', marginRight: '1.25rem' }}>
                  {coupons.map((coupon, i) => (<TagComponent
                    id={i.toString()}
                    onCloseClick={(index) => {
                      const newCoupons = [...coupons];
                      newCoupons.splice(parseInt(index), 1);
                      setCoupons(newCoupons);
                    }}
                    key={`coupon-${i}`}
                  >{coupon.code}</TagComponent>))}
                </div></>
            )
          }
          {isCreating && (
            <>
              <hr className={`${COMPONENT_CLASS}_divider ${!isCreating ? `${COMPONENT_CLASS}__upgrade-divider` : ""}`} />
              <div className={`${COMPONENT_CLASS}_summary_line`}>
                <div className={`${COMPONENT_CLASS}__summary-disclaimer`}>{t('pricing.checkoutPage.renewalInfo', { date: calculateNextPayment(product?.priceInfo) })}</div>
              </div>
            </>
          )}
        </div>
        <form onSubmit={handleSubmit} className={`${COMPONENT_CLASS}__form`} id="checkout-form">
          <PaymentElement />
        </form>
      </div>

      <div className={`${!isCreating ? `${COMPONENT_CLASS}__bottom-text-modal` : `${COMPONENT_CLASS}__bottom-text`}`} dangerouslySetInnerHTML={{ __html: t('pricing.checkoutPage.termsAndConditions') }}>
      </div>
      {!isCreating && setUpgradeModalOpen && (
        <div className={`${COMPONENT_CLASS}__start-subscription`}>
          <Button
            type="link"
            inputClassName={`${COMPONENT_CLASS}__actions__cancel`}
            buttonText={t('pricing.checkoutPage.keepCurrent')}
            onClick={() => {
              setUpgradeModalOpen(false);
            }} />
          <Button
            buttonType="submit"
            form="checkout-form"
            inputClassName="action-button"
            buttonText={t('pricing.checkoutPage.payAndUpgrade')} />

        </div>)}
    </div>
  );
}

export default CheckoutFormCreate;